<template>
  <div class="template-card" :class="{ 'check-mode': hasChecked }">
    <div class="template-cover" :class="{ cantcheck: cantcheck }" @click="handleClickTemplate">
      <img :src="item.cover" alt="" />
      <div
        v-if="!cantcheck"
        class="check-btn"
        @click.stop="handleCheck"
        :class="{ checked: item.checked }"
      >
        <i class="el-icon-check"></i>
      </div>
    </div>
    <div class="template-info">
      <el-tooltip
        popper-class="edoovo-table-cell-tooltip"
        :content="item.title"
        placement="bottom-start"
        :visible-arrow="false"
        effect="light"
      >
        <div class="template-name">{{ item.title }}</div>
      </el-tooltip>
      <gg-menu-bar>
        <i class="iconmore_vert-24px iconfont" />
        <template slot="menus">
          <gg-menu-bar-item
            :class="{ 'hr-class': action.label === '|' }"
            v-for="action in actions"
            :key="action.key"
            @click="handleAction(action.key)"
          >
            <span>{{ action.label === '|' ? '' : action.label }}</span>
            <hr v-if="action.label === '|'" class="hr" />
          </gg-menu-bar-item>
        </template>
      </gg-menu-bar>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      require: true
    },
    hasChecked: {
      type: Boolean,
      default: false
    },
    cantcheck: {
      type: Boolean,
      default: false
    },
    onlyPreview: {
      type: Boolean,
      default: false
    },
    trash: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    actions() {
      let actions = []
      if (this.onlyPreview) {
        actions = [
          {
            key: 'preview',
            label: 'Preview'
          }
        ]
      } else if (this.trash) {
        actions = [
          {
            key: 'deletePermanently',
            label: 'Delete permanently'
          },
          {
            key: 'restore',
            label: 'Restore'
          }
        ]
      } else {
        actions = [
          {
            key: 'preview',
            label: 'Preview'
          },
          {
            key: this.item.status === 'DRAFT' ? 'publishTemplate' : 'unpublishTemplate',
            label: this.item.status === 'DRAFT' ? 'Publish' : 'Unpublish'
          },
          {
            key: '|',
            label: '|'
          },
          {
            key: 'edit',
            label: 'Edit'
          },
          {
            key: 'deleteTemplate',
            label: 'Delete'
          }
        ]
      }
      return actions
    }
  },
  data() {
    return {}
  },
  methods: {
    handleAction(key) {
      this.$emit('handleAction', key, this.item)
    },
    handleCheck() {
      this.$emit('handleCheck', this.item)
    },
    handleClickTemplate() {
      this.$emit('handleClickTemplate', this.item)
    }
  }
}
</script>
<style lang="less" scoped>
.template-card .menu_bar .drop_down_menus .hr-class {
  padding: 0 !important;
}
.template-card .menu_bar .drop_down_menus hr {
  margin: 5px 0;
  border-bottom: 1px solid #e0e0e0 !important;
}
.template-card {
  width: 236px;
  float: left;
  // margin: 0 8px;
  margin-right: 18px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  margin-bottom: 32px;
  .template-cover {
    position: relative;
    &:not(.cantcheck)::before {
      content: ' ';
      position: absolute;
      height: 40px;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
      opacity: 0;
      border-radius: 8px 8px 0 0;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
    }
    img {
      width: 236px;
      height: 334px;
      border-radius: 8px 8px 0 0;
    }
    .check-btn {
      width: 24px;
      height: 24px;
      position: absolute;
      z-index: 3;
      left: 8px;
      top: 8px;
      border-radius: 100%;
      background: transparent;
      border: 2px solid #fff;
      opacity: 0;

      .el-icon-check {
        color: #999;
        width: 20px;
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
        display: none;
      }

      &.checked {
        background: #1a73e8;
        border-color: #1a73e8;
        opacity: 1;
        .el-icon-check {
          display: block;
          color: #fff;
        }
      }
    }
    &:hover {
      .check-btn:not(.checked) {
        opacity: 0.5;
        background: #fff;
        .el-icon-check {
          display: block;
        }
      }
      &::before {
        opacity: 1;
      }
    }
  }
  .template-info {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #e0e0e0;
    padding-left: 20px;
    padding-right: 12px;
    .template-name {
      font-family: Roboto-Medium;
      font-size: 16px;
      color: #202124;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 164px;
    }
    /deep/.menu_bar {
      font-size: 20px;
      flex: none;
      .menu_bar_button {
        .iconfont {
          font-size: 20px;
        }
      }
    }
  }
  &.check-mode {
    .template-cover {
      .check-btn {
        opacity: 1;
      }
      &::before {
        opacity: 1;
      }
    }
  }
}
</style>
